export enum Permissions {
  View = 'view',
  Comment = 'comment',
  Edit = 'edit',
  Invite = 'invite',
  Approve = 'approve',
  Whitelist = 'whitelist',
  EditTemplates = 'edit_templates',
  ManageTemplates = 'manage_templates',
}

export type PermissionsKeys = (typeof Permissions)[keyof typeof Permissions];
